var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBusinessCard = function SvgBusinessCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "business-card_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".business-card_svg__st0{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 5h21c.6 0 1 .4 1 1v15c0 .6-.4 1-1 1h-21c-.6 0-1-.4-1-1V6c0-.6.4-1 1-1",
    className: "business-card_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 7v4.5c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5V4c0-1.1-.9-2-2-2s-2 .9-2 2v1M9.5 10h11M8.5 14h12M3.5 18h17",
    className: "business-card_svg__st0"
  })));
};
export default SvgBusinessCard;